import ReactGA from 'react-ga4';
import { getCurrentEnvironment, getHostName } from '../apiEndpoint/apiEndpoint.js';
import { trackingEnabled } from './trackerGoogle.js';

var setupScript = function (forceEnabled, disableCookies) {
    var tagManagerId = getCurrentEnvironment(getHostName()) === 'production' ? 'G-66C6620CQH' : 'G-NCR0R20J56';
    if (trackingEnabled() || forceEnabled) {
        var analyticsStorage = disableCookies ? 'denied' : 'granted';
        ReactGA.gtag('consent', 'default', {
            analytics_storage: analyticsStorage,
        });
        ReactGA.initialize(tagManagerId);
    }
};
var GoogleAnalytics = function (_a) {
    var _b = _a.enabled, enabled = _b === void 0 ? false : _b, _c = _a.disableCookies, disableCookies = _c === void 0 ? false : _c;
    setupScript(enabled, disableCookies);
    return null;
};

export { GoogleAnalytics as default, setupScript };
